import { useEffect, useState } from 'react';
import type { Me } from '@jerome2/shared';
import { api, ApiError, setUnauthorizedHandler } from '../api.ts';
import { Login } from './Login.tsx';
import { Shell } from '../shell/Shell.tsx';
import { rememberDeepLink } from '../lib/deeplink.ts';
import { watchCapabilities } from '../state/app.ts';

type State = { status: 'laden' } | { status: 'login'; message?: string } | { status: 'klaar'; me: Me };

export function App() {
  const [state, setState] = useState<State>({ status: 'laden' });

  useEffect(() => {
    setUnauthorizedHandler(() => setState({ status: 'login' }));
    api<Me>('/api/me')
      .then((me) => setState({ status: 'klaar', me }))
      .catch((e: unknown) => {
        rememberDeepLink();
        if (e instanceof ApiError && e.status === 401) setState({ status: 'login' });
        else setState({ status: 'login', message: `Jerome is even niet bereikbaar: ${(e as Error).message}` });
      });
    return () => setUnauthorizedHandler(null);
  }, []);

  // Ingelogd: weten wat de server kan (versturen, spraak), zodat knoppen vooraf kloppen; opnieuw na een onderbreking.
  const loggedIn = state.status === 'klaar';
  useEffect(() => (loggedIn ? watchCapabilities() : undefined), [loggedIn]);

  if (state.status === 'laden') return <div className="min-h-full flex items-center justify-center text-muted">Jerome start op…</div>;
  if (state.status === 'login') return <Login {...(state.message ? { message: state.message } : {})} />;
  return <Shell me={state.me} />;
}
